// src/components/Layout/Layout.js
import React, { useState, useCallback } from 'react';
import { Box, useMediaQuery } from '@mui/material';
import Navbar, { NAVBAR_HEIGHT } from '../Navbar';
import Sidebar, { DRAWER_WIDTH } from '../Sidebar';

export default function Layout({ children }) {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const isMobile = useMediaQuery('(max-width:899px)');

  const handleToggleSidebar = useCallback(() => {
    setSidebarOpen((prev) => !prev);
  }, []);

  return (
    <Box sx={{ 
      display: 'flex',
      minHeight: '100vh',
      overflow: 'hidden'  // Prevent entire page scrolling
    }}>
      {/* Navbar (always on top) */}
      <Box sx={{ position: 'fixed', top: 0, left: 0, right: 0, zIndex: 1400 }}>
        <Navbar onToggleSidebar={handleToggleSidebar} />
      </Box>

      {/* Sidebar */}
      <Sidebar
        open={sidebarOpen}
        onToggle={handleToggleSidebar}
        navbarHeight={NAVBAR_HEIGHT}
      />

      {/* Page Content - Fixed scrolling section */}
      <Box
        sx={{
          mt: `${NAVBAR_HEIGHT}px`,
          ml: { xs: 0, md: `${DRAWER_WIDTH}px` },
          p: 3,
          width: '100%',
          height: `calc(100vh - ${NAVBAR_HEIGHT}px)`,
          overflowY: 'auto',  // Vertical scrolling only for content
          overflowX: 'hidden', // Hide horizontal scrollbar
          boxSizing: 'border-box',
        }}
      >
        <Box sx={{ 
          maxWidth: '100%', 
          overflowX: 'hidden', // Prevent content overflow
        }}>
          {children}
        </Box>
      </Box>
    </Box>
  );
}